import { types } from "./types";

export const mutations = {
  [types.UPDATE_CART](state, cart) {
    state.data = cart;
  },

  [types.UPDATE_CART_IGNORE_SUBSCRIBE](state, cart) {
    state.data = cart;
  },

  [types.UPDATE_NOTE_SUCCESS](state, note) {
    state.data.note = note;
  },

  [types.CLEAR_NOTE_SUCCESS](state) {
    state.data.note = "";
  },

  TOGGLE_CART(state) {
    state.open = !state.open;
  },

  TOGGLE_GIFT_FORM(state) {
    state.giftFormOpen = !state.giftFormOpen;
  },

  CLOSE_GIFT_FORM(state) {
    state.giftFormOpen = false;
  },

  UPDATE_GIFT_WRAP(state, newState) {
    state.giftWrapItems = newState;
  },

  TOGGLE_GIFT_WRAP(state) {
    state.giftWrapOpen = !state.giftWrapOpen;
  },

  CLOSE_GIFT_WRAP(state) {
    state.giftWrapOpen = false;
  },
};
